// Accounting path
export const ACCOUNTING_PATHS = {
  ACCOUNTING_TRANSACTIONS: "/transactions/accounting",
  XERO_SETUP: "/xero/account",
  NETSUITE_SETUP: "/netsuite/account",
  IMPORT_BILL_FROM_XERO: "/bills/xero",
  NETSUITE_CALLBACK: "/accounting/codat/callback",
};
